import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import { Loading } from "@/components/common";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NewExchange from "@/pages/NewExchange";
import Exchanges from "@/pages/Exchanges";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Returns from "@/pages/Returns";
import Pool from "@/pages/Pool";
import Catalog from "@/pages/Catalog";
import Payments from "@/pages/Payments";
import NetworkPage from "@/pages/NetworkPage";
import Config from "@/pages/Config";
import AuditLog from "@/pages/AuditLog";
import PaymentResult from "@/pages/PaymentResult";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function Guest() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user) return <Navigate to={user.role === "operator" ? "/cambio" : "/"} replace />;
  return <Login />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Guest />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/cambio" element={<Protected><NewExchange /></Protected>} />
      <Route path="/cambi" element={<Protected><Exchanges /></Protected>} />
      <Route path="/clienti" element={<Protected><Customers /></Protected>} />
      <Route path="/clienti/:id" element={<Protected><CustomerDetail /></Protected>} />
      <Route path="/restituzioni" element={<Protected><Returns /></Protected>} />
      <Route path="/biancheria" element={<Protected><Pool /></Protected>} />
      <Route path="/catalogo" element={<Protected><Catalog /></Protected>} />
      <Route path="/pagamenti" element={<Protected><Payments /></Protected>} />
      <Route path="/network" element={<Protected><NetworkPage /></Protected>} />
      <Route path="/operatori" element={<Protected><Config /></Protected>} />
      <Route path="/audit" element={<Protected><AuditLog /></Protected>} />
      <Route path="/payment/success" element={<Protected><PaymentResult /></Protected>} />
      <Route path="/payment/cancel" element={<Protected><PaymentResult /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
